import React from 'react';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { GridColumns } from '@material-ui/data-grid';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { AxiosResponse, CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { useGame } from '@domain/game.selection/game.selection.hook';
import { GameType } from '@domain/game.selection/types/game.type';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';

const columnsRex = [
  { field: 'flag', headerName: 'Flag', width: 270 },
  { field: 'coins', headerName: 'Coins', width: 190 },
  { field: 'creationDate', headerName: 'Creation Date', ...formatColWithDate, width: 190 },
  { field: 'collectionDate', headerName: 'Collection Date', ...formatColWithDate, width: 190 },
];

const columnsPraia: GridColumns = [...columnsRex];
columnsPraia.splice(2, 0, { field: 'cash', headerName: 'Greens', width: 190 });

interface MassCollectionsInfo {
  flag: string;
  creationDate: string;
  collectionDate: string;
  coins: number;
  cash: number;
}

let index = 0;
function createData(info: MassCollectionsInfo) {
  index += 1;
  return { id: index, ...info };
}

const PlayerMassCollections = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const game = useGame();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices
      .get<MassCollectionsInfo[]>(`/admin/mass-collections/${requestPid}`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: [] } as AxiosResponse<MassCollectionsInfo[]>;
        throw error;
      });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });
  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  return (
    <>
      <TabTableContainer>
        <MainDataGrid
          columns={game.type === GameType.Praia ? columnsPraia : columnsRex}
          rows={rows}
          loading={loading}
          error={error}
          pageCount={pageCount}
        />
      </TabTableContainer>
    </>
  );
};

export default PlayerMassCollections;
